// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.avatar_180aee16 {
  display: block;
}
.avatar_180aee16 img {
  height: auto;
  flex-shrink: 0;
  object-fit: cover;
}
.avatar_180aee16[type="button"] {
  padding: 0;
  border: none;
  background-color: transparent;
}
.avatar__box_180aee16 {
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  position: relative;
  width: 100%;
  height: 100%;
  color: #657682;
  border-radius: inherit;
}
.avatar__centered_180aee16 {
  position: absolute;
  top: 50%;
  left: 51%;
  transform: translate(-50%, -50%);
}
.avatar_bg_180aee16 .avatar__box_180aee16 {
  background-color: #f8f9fa;
}
.avatar_x-small_180aee16 {
  width: 1.5rem;
  min-width: 1.5rem;
  height: 1.5rem;
  font-size: 1rem;
}
.avatar_x-small_180aee16 img {
  max-height: 1.5rem;
  max-width: 1.5rem;
}
.avatar_small_180aee16 {
  width: 2rem;
  min-width: 2rem;
  height: 2rem;
  font-size: 1.334rem;
}
.avatar_small_180aee16 img {
  max-height: 2rem;
  max-width: 2rem;
}
.avatar_medium_180aee16 {
  width: 2.667rem;
  min-width: 2.667rem;
  height: 2.667rem;
  font-size: 1.667rem;
}
.avatar_medium_180aee16 img {
  max-height: 2.667rem;
  max-width: 2.667rem;
}
.avatar_normal_180aee16 {
  width: 3rem;
  min-width: 3rem;
  height: 3rem;
  font-size: 2rem;
}
.avatar_normal_180aee16 img {
  max-height: 3rem;
  max-width: 3rem;
}
.avatar_large_180aee16 {
  width: 4rem;
  min-width: 4rem;
  height: 4rem;
  font-size: 2.667rem;
}
.avatar_large_180aee16 img {
  max-height: 4rem;
  max-width: 4rem;
}
.avatar_large_180aee16 .avatar__box_180aee16 {
  border-width: 0.167rem;
}
.avatar_x-large_180aee16 {
  width: 4.667rem;
  min-width: 4.667rem;
  height: 4.667rem;
  font-size: 3rem;
}
.avatar_x-large_180aee16 img {
  max-height: 4.667rem;
  max-width: 4.667rem;
}
.avatar_x-large_180aee16 .avatar__box_180aee16 {
  border-width: 0.167rem;
}
.avatar_xx-large_180aee16 {
  width: 6rem;
  min-width: 6rem;
  height: 6rem;
  font-size: 4rem;
}
.avatar_xx-large_180aee16 img {
  max-height: 6rem;
  max-width: 6rem;
}
.avatar_xx-large_180aee16 .avatar__box_180aee16 {
  border-width: 0.167rem;
}
.avatar_rounded_180aee16 {
  border-radius: 50%;
}
.avatar_square_180aee16 {
  border: none;
}
.avatar_border_180aee16 {
  border: 0.084rem solid #dce1e5;
  background-color: #fff;
}
.avatar_fav-icon-xxs_180aee16 {
  width: 0.167rem;
  min-width: 0.167rem;
  height: 0.167rem;
}
.avatar_fav-icon-xxs_180aee16 img {
  max-height: 0.167rem;
  max-width: 0.167rem;
}
.avatar_fav-icon-xs_180aee16 {
  width: 0.334rem;
  min-width: 0.334rem;
  height: 0.334rem;
}
.avatar_fav-icon-xs_180aee16 img {
  max-height: 0.334rem;
  max-width: 0.334rem;
}
.avatar_fav-icon-s_180aee16 {
  width: 0.667rem;
  min-width: 0.667rem;
  height: 0.667rem;
}
.avatar_fav-icon-s_180aee16 img {
  max-height: 0.667rem;
  max-width: 0.667rem;
}
.avatar_fav-icon-sm_180aee16 {
  width: 1rem;
  min-width: 1rem;
  height: 1rem;
}
.avatar_fav-icon-sm_180aee16 img {
  max-height: 1rem;
  max-width: 1rem;
}
.avatar_fav-icon-m_180aee16 {
  width: 1.334rem;
  min-width: 1.334rem;
  height: 1.334rem;
}
.avatar_fav-icon-m_180aee16 img {
  max-height: 1.334rem;
  max-width: 1.334rem;
}
.avatar_fav-icon-l_180aee16 {
  width: 2rem;
  min-width: 2rem;
  height: 2rem;
}
.avatar_fav-icon-l_180aee16 img {
  max-height: 2rem;
  max-width: 2rem;
}
.avatar_fav-icon-xl_180aee16 {
  width: 2.667rem;
  min-width: 2.667rem;
  height: 2.667rem;
}
.avatar_fav-icon-xl_180aee16 img {
  max-height: 2.667rem;
  max-width: 2.667rem;
}
.avatar_fav-icon-xls_180aee16 {
  width: 4rem;
  min-width: 4rem;
  height: 4rem;
}
.avatar_fav-icon-xls_180aee16 img {
  max-height: 4rem;
  max-width: 4rem;
}
.avatar_fav-icon-xxl_180aee16 {
  width: 5.334rem;
  min-width: 5.334rem;
  height: 5.334rem;
}
.avatar_fav-icon-xxl_180aee16 img {
  max-height: 5.334rem;
  max-width: 5.334rem;
}
.avatar_fav-icon-xxxl_180aee16 {
  width: 10.667rem;
  min-width: 10.667rem;
  height: 10.667rem;
}
.avatar_fav-icon-xxxl_180aee16 img {
  max-height: 10.667rem;
  max-width: 10.667rem;
}
.avatar__person_180aee16 .avatar__box_180aee16 {
  font-size: 3rem;
}
.avatar__person_180aee16.avatar_x-small_180aee16 .avatar__box_180aee16 {
  font-size: 17px;
}
.avatar__person_180aee16.avatar_small_180aee16 .avatar__box_180aee16 {
  font-size: 22px;
}
.avatar__person_180aee16.avatar_medium_180aee16 .avatar__box_180aee16 {
  font-size: 30px;
}
.avatar__person_180aee16.avatar_large_180aee16 .avatar__box_180aee16 {
  font-size: 46px;
}
.avatar__person_180aee16.avatar_x-large_180aee16 .avatar__box_180aee16 {
  font-size: 54px;
}
.avatar__person_180aee16.avatar_xx-large_180aee16 .avatar__box_180aee16 {
  font-size: 70px;
}
.avatar__initials_180aee16 .avatar__box_180aee16 {
  font-size: 1rem;
  line-height: 1;
}
.avatar__initials_color-blue_180aee16 .avatar__box_180aee16 {
  color: #1d5080;
  border-color: #1d5080;
}
.avatar__initials_color-green_180aee16 .avatar__box_180aee16 {
  color: #40c2c9;
  border-color: #40c2c9;
}
.avatar__initials_color-skyBlue_180aee16 .avatar__box_180aee16 {
  color: #267479;
  border-color: #267479;
}
.avatar__initials_color-lightBlue_180aee16 .avatar__box_180aee16 {
  color: #f5c914;
  border-color: #f5c914;
}
.avatar__initials_color-yellow_180aee16 .avatar__box_180aee16 {
  color: #a26426;
  border-color: #a26426;
}
.avatar__initials_color-aqua_180aee16 .avatar__box_180aee16 {
  color: #0f345c;
  border-color: #0f345c;
}
.avatar__initials_color-tropicalForest_180aee16 .avatar__box_180aee16 {
  color: #78766f;
  border-color: #78766f;
}
.avatar__initials_color-plum_180aee16 .avatar__box_180aee16 {
  color: #c0bcb2;
  border-color: #c0bcb2;
}
.avatar__initials_color-orange_180aee16 .avatar__box_180aee16 {
  color: #e88f36;
  border-color: #e88f36;
}
.avatar__initials_color-gray_180aee16 .avatar__box_180aee16 {
  color: #1a4f52;
  border-color: #1a4f52;
}
.avatar__initials_color-plumDark_180aee16 .avatar__box_180aee16 {
  color: #c4a110;
  border-color: #c4a110;
}
.avatar__initials_color-yellowLight_180aee16 .avatar__box_180aee16 {
  color: #6185a6;
  border-color: #6185a6;
}
.avatar__initials_color-grayDark_180aee16 .avatar__box_180aee16 {
  color: #bbcbd9;
  border-color: #bbcbd9;
}
.avatar__initials_color-darkOrangeDark_180aee16 .avatar__box_180aee16 {
  color: #657682;
  border-color: #657682;
}
.avatar__initials_180aee16.avatar_x-small_180aee16 .avatar__box_180aee16 {
  font-size: 6px;
}
.avatar__initials_180aee16.avatar_small_180aee16 .avatar__box_180aee16 {
  font-size: 8px;
}
.avatar__initials_180aee16.avatar_medium_180aee16 .avatar__box_180aee16 {
  font-size: 12px;
}
.avatar__initials_180aee16.avatar_large_180aee16 .avatar__box_180aee16 {
  font-size: 18px;
}
.avatar__initials_180aee16.avatar_x-large_180aee16 .avatar__box_180aee16 {
  font-size: 20px;
}
.avatar__initials_180aee16.avatar_xx-large_180aee16 .avatar__box_180aee16 {
  font-size: 26px;
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"avatar": `avatar_180aee16`,
	"avatar__box": `avatar__box_180aee16`,
	"avatar__centered": `avatar__centered_180aee16`,
	"avatar_bg": `avatar_bg_180aee16`,
	"avatar_x-small": `avatar_x-small_180aee16`,
	"avatar_small": `avatar_small_180aee16`,
	"avatar_medium": `avatar_medium_180aee16`,
	"avatar_normal": `avatar_normal_180aee16`,
	"avatar_large": `avatar_large_180aee16`,
	"avatar_x-large": `avatar_x-large_180aee16`,
	"avatar_xx-large": `avatar_xx-large_180aee16`,
	"avatar_rounded": `avatar_rounded_180aee16`,
	"avatar_square": `avatar_square_180aee16`,
	"avatar_border": `avatar_border_180aee16`,
	"avatar_fav-icon-xxs": `avatar_fav-icon-xxs_180aee16`,
	"avatar_fav-icon-xs": `avatar_fav-icon-xs_180aee16`,
	"avatar_fav-icon-s": `avatar_fav-icon-s_180aee16`,
	"avatar_fav-icon-sm": `avatar_fav-icon-sm_180aee16`,
	"avatar_fav-icon-m": `avatar_fav-icon-m_180aee16`,
	"avatar_fav-icon-l": `avatar_fav-icon-l_180aee16`,
	"avatar_fav-icon-xl": `avatar_fav-icon-xl_180aee16`,
	"avatar_fav-icon-xls": `avatar_fav-icon-xls_180aee16`,
	"avatar_fav-icon-xxl": `avatar_fav-icon-xxl_180aee16`,
	"avatar_fav-icon-xxxl": `avatar_fav-icon-xxxl_180aee16`,
	"avatar__person": `avatar__person_180aee16`,
	"avatar__initials": `avatar__initials_180aee16`,
	"avatar__initials_color-blue": `avatar__initials_color-blue_180aee16`,
	"avatar__initials_color-green": `avatar__initials_color-green_180aee16`,
	"avatar__initials_color-skyBlue": `avatar__initials_color-skyBlue_180aee16`,
	"avatar__initials_color-lightBlue": `avatar__initials_color-lightBlue_180aee16`,
	"avatar__initials_color-yellow": `avatar__initials_color-yellow_180aee16`,
	"avatar__initials_color-aqua": `avatar__initials_color-aqua_180aee16`,
	"avatar__initials_color-tropicalForest": `avatar__initials_color-tropicalForest_180aee16`,
	"avatar__initials_color-plum": `avatar__initials_color-plum_180aee16`,
	"avatar__initials_color-orange": `avatar__initials_color-orange_180aee16`,
	"avatar__initials_color-gray": `avatar__initials_color-gray_180aee16`,
	"avatar__initials_color-plumDark": `avatar__initials_color-plumDark_180aee16`,
	"avatar__initials_color-yellowLight": `avatar__initials_color-yellowLight_180aee16`,
	"avatar__initials_color-grayDark": `avatar__initials_color-grayDark_180aee16`,
	"avatar__initials_color-darkOrangeDark": `avatar__initials_color-darkOrangeDark_180aee16`
};
export default ___CSS_LOADER_EXPORT___;
